var index = {
  root: {
    transitionDuration: '{transition.duration}',
  },
  tablist: {
    borderWidth: '0 0 5px 0',
    background: 'transparent',
    borderColor: 'transparent',
  },
  tab: {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderWidth: '0 0 5px 0',
    borderColor: 'transparent',
    hoverBorderColor: '{content.border.color}',
    activeBorderColor: '{primary.color}',
    color: '{text.color}',
    hoverColor: '{primary.color}',
    activeColor: '{text.color}',
    padding: '1rem 1.125rem',
    fontWeight: '500',
    margin: '0 0 -5px 0',
    gap: '0.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-5px',
      shadow: '{focus.ring.shadow}',
    },
  },
  tabpanel: {
    background: '{content.background}',
    color: '{content.color}',
    padding: '0',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '{focus.ring.offset}',
      shadow: 'inset {focus.ring.shadow}',
    },
  },
  navButton: {
    background: '{content.background}',
    color: '{text.muted.color}',
    hoverColor: '{text.color}',
    width: '2.5rem',
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: '{focus.ring.color}',
      offset: '-1px',
      shadow: '{focus.ring.shadow}',
    },
  },
  activeBar: {
    height: '5px',
    bottom: '-5px',
    background: '{primary.color}',
  },
  colorScheme: {
    light: {
      navButton: {
        shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)',
      },
    },
    dark: {
      navButton: {
        shadow: '0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)',
      },
    },
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
